import { default as index6Tezf4xDR0Meta } from "/app/apps/main/pages/index.vue?macro=true";
import { default as cookiemOAxaPzMUYMeta } from "/app/apps/main/pages/about/cookie.vue?macro=true";
import { default as license_45agreementkMCPmzGS60Meta } from "/app/apps/main/pages/about/license-agreement.vue?macro=true";
import { default as partner_45agreement3wqfvMNldcMeta } from "/app/apps/main/pages/about/partner-agreement.vue?macro=true";
import { default as privacy_45policyGmXsOoYOXcMeta } from "/app/apps/main/pages/about/privacy-policy.vue?macro=true";
import { default as user_45agreementoTBL7dn38CMeta } from "/app/apps/main/pages/about/user-agreement.vue?macro=true";
import { default as beautyVtIuWHkWI8Meta } from "/app/apps/main/pages/beauty.vue?macro=true";
import { default as calendar0drTT6QEafMeta } from "/app/apps/main/pages/calendar.vue?macro=true";
import { default as contactsJOJFOzPHdXMeta } from "/app/apps/main/pages/client/about/contacts.vue?macro=true";
import { default as indexBs7SYpuJobMeta } from "/app/apps/main/pages/client/about/index.vue?macro=true";
import { default as questionsZkYGPOPQK7Meta } from "/app/apps/main/pages/client/about/questions.vue?macro=true";
import { default as ratesDA2lxZX7FqMeta } from "/app/apps/main/pages/client/about/rates.vue?macro=true";
import { default as connectjpWmyyndlzMeta } from "/app/apps/main/pages/client/connect.vue?macro=true";
import { default as indexahoCwrwkCWMeta } from "/app/apps/main/pages/client/index.vue?macro=true";
import { default as partnernG7hRthyquMeta } from "/app/apps/main/pages/client/partner.vue?macro=true";
import { default as profilehwEWxnxaMzMeta } from "/app/apps/main/pages/client/profile.vue?macro=true";
import { default as projectsTzwPWuFgDlMeta } from "/app/apps/main/pages/client/projects.vue?macro=true";
import { default as contactslJPNFNcbUzMeta } from "/app/apps/main/pages/contacts.vue?macro=true";
import { default as ecommercez95puyJA1PMeta } from "/app/apps/main/pages/ecommerce.vue?macro=true";
import { default as _91slug_9332NUrlielcMeta } from "/app/apps/main/pages/faq/articles/[slug].vue?macro=true";
import { default as indexugczcE0HZkMeta } from "/app/apps/main/pages/faq/articles/index.vue?macro=true";
import { default as _91slug_93gVK0W4WnLsMeta } from "/app/apps/main/pages/faq/categories/[slug].vue?macro=true";
import { default as indexJpbpNzyvlWMeta } from "/app/apps/main/pages/faq/categories/index.vue?macro=true";
import { default as indexIL2hD91X5QMeta } from "/app/apps/main/pages/faq/index.vue?macro=true";
import { default as botYfoz4JhNx4Meta } from "/app/apps/main/pages/features/bot.vue?macro=true";
import { default as chatswSyv7QNytqMeta } from "/app/apps/main/pages/features/chats.vue?macro=true";
import { default as client_45cabinetSmramCG06BMeta } from "/app/apps/main/pages/features/client-cabinet.vue?macro=true";
import { default as crmjQQDQZYNJrMeta } from "/app/apps/main/pages/features/crm.vue?macro=true";
import { default as online_45recordI6Ty3InfF8Meta } from "/app/apps/main/pages/features/online-record.vue?macro=true";
import { default as services_45with_45applicationsSVbplky9tgMeta } from "/app/apps/main/pages/features/services-with-applications.vue?macro=true";
import { default as shopkVBbHRJJGDMeta } from "/app/apps/main/pages/features/shop.vue?macro=true";
import { default as websiteHuL6hWGxPrMeta } from "/app/apps/main/pages/features/website.vue?macro=true";
import { default as oldVK0re4oWPXMeta } from "/app/apps/main/pages/old.vue?macro=true";
import { default as partners_oldh4rrhvu8bmMeta } from "/app/apps/main/pages/partners_old.vue?macro=true";
import { default as partners4d3zuQK8P5Meta } from "/app/apps/main/pages/partners.vue?macro=true";
import { default as questionszzlBDIjGzhMeta } from "/app/apps/main/pages/questions.vue?macro=true";
import { default as ratesMvfz8jSJahMeta } from "/app/apps/main/pages/rates.vue?macro=true";
import { default as _91token_93DgAnvUd3UKMeta } from "/app/apps/main/pages/registration/[token].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index6Tezf4xDR0Meta || {},
    component: () => import("/app/apps/main/pages/index.vue")
  },
  {
    name: "about-cookie___ru",
    path: "/ru/about/cookie",
    component: () => import("/app/apps/main/pages/about/cookie.vue")
  },
  {
    name: "about-cookie___en",
    path: "/en/about/cookie",
    component: () => import("/app/apps/main/pages/about/cookie.vue")
  },
  {
    name: "about-cookie___ka",
    path: "/ka/about/cookie",
    component: () => import("/app/apps/main/pages/about/cookie.vue")
  },
  {
    name: "about-cookie___uz",
    path: "/uz/about/cookie",
    component: () => import("/app/apps/main/pages/about/cookie.vue")
  },
  {
    name: "about-license-agreement___ru",
    path: "/ru/about/license-agreement",
    component: () => import("/app/apps/main/pages/about/license-agreement.vue")
  },
  {
    name: "about-license-agreement___en",
    path: "/en/about/license-agreement",
    component: () => import("/app/apps/main/pages/about/license-agreement.vue")
  },
  {
    name: "about-license-agreement___ka",
    path: "/ka/about/license-agreement",
    component: () => import("/app/apps/main/pages/about/license-agreement.vue")
  },
  {
    name: "about-license-agreement___uz",
    path: "/uz/about/license-agreement",
    component: () => import("/app/apps/main/pages/about/license-agreement.vue")
  },
  {
    name: "about-partner-agreement___ru",
    path: "/ru/about/partner-agreement",
    component: () => import("/app/apps/main/pages/about/partner-agreement.vue")
  },
  {
    name: "about-partner-agreement___en",
    path: "/en/about/partner-agreement",
    component: () => import("/app/apps/main/pages/about/partner-agreement.vue")
  },
  {
    name: "about-partner-agreement___ka",
    path: "/ka/about/partner-agreement",
    component: () => import("/app/apps/main/pages/about/partner-agreement.vue")
  },
  {
    name: "about-partner-agreement___uz",
    path: "/uz/about/partner-agreement",
    component: () => import("/app/apps/main/pages/about/partner-agreement.vue")
  },
  {
    name: "about-privacy-policy___ru",
    path: "/ru/about/privacy-policy",
    component: () => import("/app/apps/main/pages/about/privacy-policy.vue")
  },
  {
    name: "about-privacy-policy___en",
    path: "/en/about/privacy-policy",
    component: () => import("/app/apps/main/pages/about/privacy-policy.vue")
  },
  {
    name: "about-privacy-policy___ka",
    path: "/ka/about/privacy-policy",
    component: () => import("/app/apps/main/pages/about/privacy-policy.vue")
  },
  {
    name: "about-privacy-policy___uz",
    path: "/uz/about/privacy-policy",
    component: () => import("/app/apps/main/pages/about/privacy-policy.vue")
  },
  {
    name: "about-user-agreement___ru",
    path: "/ru/about/user-agreement",
    component: () => import("/app/apps/main/pages/about/user-agreement.vue")
  },
  {
    name: "about-user-agreement___en",
    path: "/en/about/user-agreement",
    component: () => import("/app/apps/main/pages/about/user-agreement.vue")
  },
  {
    name: "about-user-agreement___ka",
    path: "/ka/about/user-agreement",
    component: () => import("/app/apps/main/pages/about/user-agreement.vue")
  },
  {
    name: "about-user-agreement___uz",
    path: "/uz/about/user-agreement",
    component: () => import("/app/apps/main/pages/about/user-agreement.vue")
  },
  {
    name: "beauty___ru",
    path: "/ru/beauty",
    meta: beautyVtIuWHkWI8Meta || {},
    component: () => import("/app/apps/main/pages/beauty.vue")
  },
  {
    name: "beauty___en",
    path: "/en/beauty",
    meta: beautyVtIuWHkWI8Meta || {},
    component: () => import("/app/apps/main/pages/beauty.vue")
  },
  {
    name: "beauty___ka",
    path: "/ka/beauty",
    meta: beautyVtIuWHkWI8Meta || {},
    component: () => import("/app/apps/main/pages/beauty.vue")
  },
  {
    name: "beauty___uz",
    path: "/uz/beauty",
    meta: beautyVtIuWHkWI8Meta || {},
    component: () => import("/app/apps/main/pages/beauty.vue")
  },
  {
    name: "calendar___ru",
    path: "/ru/calendar",
    component: () => import("/app/apps/main/pages/calendar.vue")
  },
  {
    name: "calendar___en",
    path: "/en/calendar",
    component: () => import("/app/apps/main/pages/calendar.vue")
  },
  {
    name: "calendar___ka",
    path: "/ka/calendar",
    component: () => import("/app/apps/main/pages/calendar.vue")
  },
  {
    name: "calendar___uz",
    path: "/uz/calendar",
    component: () => import("/app/apps/main/pages/calendar.vue")
  },
  {
    name: "client-about-contacts___ru",
    path: "/ru/client/about/contacts",
    meta: contactsJOJFOzPHdXMeta || {},
    component: () => import("/app/apps/main/pages/client/about/contacts.vue")
  },
  {
    name: "client-about-contacts___en",
    path: "/en/client/about/contacts",
    meta: contactsJOJFOzPHdXMeta || {},
    component: () => import("/app/apps/main/pages/client/about/contacts.vue")
  },
  {
    name: "client-about-contacts___ka",
    path: "/ka/client/about/contacts",
    meta: contactsJOJFOzPHdXMeta || {},
    component: () => import("/app/apps/main/pages/client/about/contacts.vue")
  },
  {
    name: "client-about-contacts___uz",
    path: "/uz/client/about/contacts",
    meta: contactsJOJFOzPHdXMeta || {},
    component: () => import("/app/apps/main/pages/client/about/contacts.vue")
  },
  {
    name: "client-about___ru",
    path: "/ru/client/about",
    meta: indexBs7SYpuJobMeta || {},
    component: () => import("/app/apps/main/pages/client/about/index.vue")
  },
  {
    name: "client-about___en",
    path: "/en/client/about",
    meta: indexBs7SYpuJobMeta || {},
    component: () => import("/app/apps/main/pages/client/about/index.vue")
  },
  {
    name: "client-about___ka",
    path: "/ka/client/about",
    meta: indexBs7SYpuJobMeta || {},
    component: () => import("/app/apps/main/pages/client/about/index.vue")
  },
  {
    name: "client-about___uz",
    path: "/uz/client/about",
    meta: indexBs7SYpuJobMeta || {},
    component: () => import("/app/apps/main/pages/client/about/index.vue")
  },
  {
    name: "client-about-questions___ru",
    path: "/ru/client/about/questions",
    meta: questionsZkYGPOPQK7Meta || {},
    component: () => import("/app/apps/main/pages/client/about/questions.vue")
  },
  {
    name: "client-about-questions___en",
    path: "/en/client/about/questions",
    meta: questionsZkYGPOPQK7Meta || {},
    component: () => import("/app/apps/main/pages/client/about/questions.vue")
  },
  {
    name: "client-about-questions___ka",
    path: "/ka/client/about/questions",
    meta: questionsZkYGPOPQK7Meta || {},
    component: () => import("/app/apps/main/pages/client/about/questions.vue")
  },
  {
    name: "client-about-questions___uz",
    path: "/uz/client/about/questions",
    meta: questionsZkYGPOPQK7Meta || {},
    component: () => import("/app/apps/main/pages/client/about/questions.vue")
  },
  {
    name: "client-about-rates___ru",
    path: "/ru/client/about/rates",
    meta: ratesDA2lxZX7FqMeta || {},
    component: () => import("/app/apps/main/pages/client/about/rates.vue")
  },
  {
    name: "client-about-rates___en",
    path: "/en/client/about/rates",
    meta: ratesDA2lxZX7FqMeta || {},
    component: () => import("/app/apps/main/pages/client/about/rates.vue")
  },
  {
    name: "client-about-rates___ka",
    path: "/ka/client/about/rates",
    meta: ratesDA2lxZX7FqMeta || {},
    component: () => import("/app/apps/main/pages/client/about/rates.vue")
  },
  {
    name: "client-about-rates___uz",
    path: "/uz/client/about/rates",
    meta: ratesDA2lxZX7FqMeta || {},
    component: () => import("/app/apps/main/pages/client/about/rates.vue")
  },
  {
    name: "client-connect___ru",
    path: "/ru/client/connect",
    meta: connectjpWmyyndlzMeta || {},
    component: () => import("/app/apps/main/pages/client/connect.vue")
  },
  {
    name: "client-connect___en",
    path: "/en/client/connect",
    meta: connectjpWmyyndlzMeta || {},
    component: () => import("/app/apps/main/pages/client/connect.vue")
  },
  {
    name: "client-connect___ka",
    path: "/ka/client/connect",
    meta: connectjpWmyyndlzMeta || {},
    component: () => import("/app/apps/main/pages/client/connect.vue")
  },
  {
    name: "client-connect___uz",
    path: "/uz/client/connect",
    meta: connectjpWmyyndlzMeta || {},
    component: () => import("/app/apps/main/pages/client/connect.vue")
  },
  {
    name: "client___ru",
    path: "/ru/client",
    component: () => import("/app/apps/main/pages/client/index.vue")
  },
  {
    name: "client___en",
    path: "/en/client",
    component: () => import("/app/apps/main/pages/client/index.vue")
  },
  {
    name: "client___ka",
    path: "/ka/client",
    component: () => import("/app/apps/main/pages/client/index.vue")
  },
  {
    name: "client___uz",
    path: "/uz/client",
    component: () => import("/app/apps/main/pages/client/index.vue")
  },
  {
    name: "client-partner___ru",
    path: "/ru/client/partner",
    meta: partnernG7hRthyquMeta || {},
    component: () => import("/app/apps/main/pages/client/partner.vue")
  },
  {
    name: "client-partner___en",
    path: "/en/client/partner",
    meta: partnernG7hRthyquMeta || {},
    component: () => import("/app/apps/main/pages/client/partner.vue")
  },
  {
    name: "client-partner___ka",
    path: "/ka/client/partner",
    meta: partnernG7hRthyquMeta || {},
    component: () => import("/app/apps/main/pages/client/partner.vue")
  },
  {
    name: "client-partner___uz",
    path: "/uz/client/partner",
    meta: partnernG7hRthyquMeta || {},
    component: () => import("/app/apps/main/pages/client/partner.vue")
  },
  {
    name: "client-profile___ru",
    path: "/ru/client/profile",
    meta: profilehwEWxnxaMzMeta || {},
    component: () => import("/app/apps/main/pages/client/profile.vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: profilehwEWxnxaMzMeta || {},
    component: () => import("/app/apps/main/pages/client/profile.vue")
  },
  {
    name: "client-profile___ka",
    path: "/ka/client/profile",
    meta: profilehwEWxnxaMzMeta || {},
    component: () => import("/app/apps/main/pages/client/profile.vue")
  },
  {
    name: "client-profile___uz",
    path: "/uz/client/profile",
    meta: profilehwEWxnxaMzMeta || {},
    component: () => import("/app/apps/main/pages/client/profile.vue")
  },
  {
    name: "client-projects___ru",
    path: "/ru/client/projects",
    meta: projectsTzwPWuFgDlMeta || {},
    component: () => import("/app/apps/main/pages/client/projects.vue")
  },
  {
    name: "client-projects___en",
    path: "/en/client/projects",
    meta: projectsTzwPWuFgDlMeta || {},
    component: () => import("/app/apps/main/pages/client/projects.vue")
  },
  {
    name: "client-projects___ka",
    path: "/ka/client/projects",
    meta: projectsTzwPWuFgDlMeta || {},
    component: () => import("/app/apps/main/pages/client/projects.vue")
  },
  {
    name: "client-projects___uz",
    path: "/uz/client/projects",
    meta: projectsTzwPWuFgDlMeta || {},
    component: () => import("/app/apps/main/pages/client/projects.vue")
  },
  {
    name: "contacts___ru",
    path: "/ru/contacts",
    component: () => import("/app/apps/main/pages/contacts.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    component: () => import("/app/apps/main/pages/contacts.vue")
  },
  {
    name: "contacts___ka",
    path: "/ka/contacts",
    component: () => import("/app/apps/main/pages/contacts.vue")
  },
  {
    name: "contacts___uz",
    path: "/uz/contacts",
    component: () => import("/app/apps/main/pages/contacts.vue")
  },
  {
    name: "ecommerce___ru",
    path: "/ru/ecommerce",
    meta: ecommercez95puyJA1PMeta || {},
    component: () => import("/app/apps/main/pages/ecommerce.vue")
  },
  {
    name: "ecommerce___en",
    path: "/en/ecommerce",
    meta: ecommercez95puyJA1PMeta || {},
    component: () => import("/app/apps/main/pages/ecommerce.vue")
  },
  {
    name: "ecommerce___ka",
    path: "/ka/ecommerce",
    meta: ecommercez95puyJA1PMeta || {},
    component: () => import("/app/apps/main/pages/ecommerce.vue")
  },
  {
    name: "ecommerce___uz",
    path: "/uz/ecommerce",
    meta: ecommercez95puyJA1PMeta || {},
    component: () => import("/app/apps/main/pages/ecommerce.vue")
  },
  {
    name: "faq-articles-slug___ru",
    path: "/ru/faq/articles/:slug()",
    meta: _91slug_9332NUrlielcMeta || {},
    component: () => import("/app/apps/main/pages/faq/articles/[slug].vue")
  },
  {
    name: "faq-articles-slug___en",
    path: "/en/faq/articles/:slug()",
    meta: _91slug_9332NUrlielcMeta || {},
    component: () => import("/app/apps/main/pages/faq/articles/[slug].vue")
  },
  {
    name: "faq-articles-slug___ka",
    path: "/ka/faq/articles/:slug()",
    meta: _91slug_9332NUrlielcMeta || {},
    component: () => import("/app/apps/main/pages/faq/articles/[slug].vue")
  },
  {
    name: "faq-articles-slug___uz",
    path: "/uz/faq/articles/:slug()",
    meta: _91slug_9332NUrlielcMeta || {},
    component: () => import("/app/apps/main/pages/faq/articles/[slug].vue")
  },
  {
    name: "faq-articles___ru",
    path: "/ru/faq/articles",
    component: () => import("/app/apps/main/pages/faq/articles/index.vue")
  },
  {
    name: "faq-articles___en",
    path: "/en/faq/articles",
    component: () => import("/app/apps/main/pages/faq/articles/index.vue")
  },
  {
    name: "faq-articles___ka",
    path: "/ka/faq/articles",
    component: () => import("/app/apps/main/pages/faq/articles/index.vue")
  },
  {
    name: "faq-articles___uz",
    path: "/uz/faq/articles",
    component: () => import("/app/apps/main/pages/faq/articles/index.vue")
  },
  {
    name: "faq-categories-slug___ru",
    path: "/ru/faq/categories/:slug()",
    meta: _91slug_93gVK0W4WnLsMeta || {},
    component: () => import("/app/apps/main/pages/faq/categories/[slug].vue")
  },
  {
    name: "faq-categories-slug___en",
    path: "/en/faq/categories/:slug()",
    meta: _91slug_93gVK0W4WnLsMeta || {},
    component: () => import("/app/apps/main/pages/faq/categories/[slug].vue")
  },
  {
    name: "faq-categories-slug___ka",
    path: "/ka/faq/categories/:slug()",
    meta: _91slug_93gVK0W4WnLsMeta || {},
    component: () => import("/app/apps/main/pages/faq/categories/[slug].vue")
  },
  {
    name: "faq-categories-slug___uz",
    path: "/uz/faq/categories/:slug()",
    meta: _91slug_93gVK0W4WnLsMeta || {},
    component: () => import("/app/apps/main/pages/faq/categories/[slug].vue")
  },
  {
    name: "faq-categories___ru",
    path: "/ru/faq/categories",
    component: () => import("/app/apps/main/pages/faq/categories/index.vue")
  },
  {
    name: "faq-categories___en",
    path: "/en/faq/categories",
    component: () => import("/app/apps/main/pages/faq/categories/index.vue")
  },
  {
    name: "faq-categories___ka",
    path: "/ka/faq/categories",
    component: () => import("/app/apps/main/pages/faq/categories/index.vue")
  },
  {
    name: "faq-categories___uz",
    path: "/uz/faq/categories",
    component: () => import("/app/apps/main/pages/faq/categories/index.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    meta: indexIL2hD91X5QMeta || {},
    component: () => import("/app/apps/main/pages/faq/index.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    meta: indexIL2hD91X5QMeta || {},
    component: () => import("/app/apps/main/pages/faq/index.vue")
  },
  {
    name: "faq___ka",
    path: "/ka/faq",
    meta: indexIL2hD91X5QMeta || {},
    component: () => import("/app/apps/main/pages/faq/index.vue")
  },
  {
    name: "faq___uz",
    path: "/uz/faq",
    meta: indexIL2hD91X5QMeta || {},
    component: () => import("/app/apps/main/pages/faq/index.vue")
  },
  {
    name: "features-bot___ru",
    path: "/ru/features/bot",
    component: () => import("/app/apps/main/pages/features/bot.vue")
  },
  {
    name: "features-bot___en",
    path: "/en/features/bot",
    component: () => import("/app/apps/main/pages/features/bot.vue")
  },
  {
    name: "features-bot___ka",
    path: "/ka/features/bot",
    component: () => import("/app/apps/main/pages/features/bot.vue")
  },
  {
    name: "features-bot___uz",
    path: "/uz/features/bot",
    component: () => import("/app/apps/main/pages/features/bot.vue")
  },
  {
    name: "features-chats___ru",
    path: "/ru/features/chats",
    component: () => import("/app/apps/main/pages/features/chats.vue")
  },
  {
    name: "features-chats___en",
    path: "/en/features/chats",
    component: () => import("/app/apps/main/pages/features/chats.vue")
  },
  {
    name: "features-chats___ka",
    path: "/ka/features/chats",
    component: () => import("/app/apps/main/pages/features/chats.vue")
  },
  {
    name: "features-chats___uz",
    path: "/uz/features/chats",
    component: () => import("/app/apps/main/pages/features/chats.vue")
  },
  {
    name: "features-client-cabinet___ru",
    path: "/ru/features/client-cabinet",
    component: () => import("/app/apps/main/pages/features/client-cabinet.vue")
  },
  {
    name: "features-client-cabinet___en",
    path: "/en/features/client-cabinet",
    component: () => import("/app/apps/main/pages/features/client-cabinet.vue")
  },
  {
    name: "features-client-cabinet___ka",
    path: "/ka/features/client-cabinet",
    component: () => import("/app/apps/main/pages/features/client-cabinet.vue")
  },
  {
    name: "features-client-cabinet___uz",
    path: "/uz/features/client-cabinet",
    component: () => import("/app/apps/main/pages/features/client-cabinet.vue")
  },
  {
    name: "features-crm___ru",
    path: "/ru/features/crm",
    component: () => import("/app/apps/main/pages/features/crm.vue")
  },
  {
    name: "features-crm___en",
    path: "/en/features/crm",
    component: () => import("/app/apps/main/pages/features/crm.vue")
  },
  {
    name: "features-crm___ka",
    path: "/ka/features/crm",
    component: () => import("/app/apps/main/pages/features/crm.vue")
  },
  {
    name: "features-crm___uz",
    path: "/uz/features/crm",
    component: () => import("/app/apps/main/pages/features/crm.vue")
  },
  {
    name: "features-online-record___ru",
    path: "/ru/features/online-record",
    component: () => import("/app/apps/main/pages/features/online-record.vue")
  },
  {
    name: "features-online-record___en",
    path: "/en/features/online-record",
    component: () => import("/app/apps/main/pages/features/online-record.vue")
  },
  {
    name: "features-online-record___ka",
    path: "/ka/features/online-record",
    component: () => import("/app/apps/main/pages/features/online-record.vue")
  },
  {
    name: "features-online-record___uz",
    path: "/uz/features/online-record",
    component: () => import("/app/apps/main/pages/features/online-record.vue")
  },
  {
    name: "features-services-with-applications___ru",
    path: "/ru/features/services-with-applications",
    component: () => import("/app/apps/main/pages/features/services-with-applications.vue")
  },
  {
    name: "features-services-with-applications___en",
    path: "/en/features/services-with-applications",
    component: () => import("/app/apps/main/pages/features/services-with-applications.vue")
  },
  {
    name: "features-services-with-applications___ka",
    path: "/ka/features/services-with-applications",
    component: () => import("/app/apps/main/pages/features/services-with-applications.vue")
  },
  {
    name: "features-services-with-applications___uz",
    path: "/uz/features/services-with-applications",
    component: () => import("/app/apps/main/pages/features/services-with-applications.vue")
  },
  {
    name: "features-shop___ru",
    path: "/ru/features/shop",
    component: () => import("/app/apps/main/pages/features/shop.vue")
  },
  {
    name: "features-shop___en",
    path: "/en/features/shop",
    component: () => import("/app/apps/main/pages/features/shop.vue")
  },
  {
    name: "features-shop___ka",
    path: "/ka/features/shop",
    component: () => import("/app/apps/main/pages/features/shop.vue")
  },
  {
    name: "features-shop___uz",
    path: "/uz/features/shop",
    component: () => import("/app/apps/main/pages/features/shop.vue")
  },
  {
    name: "features-website___ru",
    path: "/ru/features/website",
    component: () => import("/app/apps/main/pages/features/website.vue")
  },
  {
    name: "features-website___en",
    path: "/en/features/website",
    component: () => import("/app/apps/main/pages/features/website.vue")
  },
  {
    name: "features-website___ka",
    path: "/ka/features/website",
    component: () => import("/app/apps/main/pages/features/website.vue")
  },
  {
    name: "features-website___uz",
    path: "/uz/features/website",
    component: () => import("/app/apps/main/pages/features/website.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: index6Tezf4xDR0Meta || {},
    component: () => import("/app/apps/main/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index6Tezf4xDR0Meta || {},
    component: () => import("/app/apps/main/pages/index.vue")
  },
  {
    name: "index___ka",
    path: "/ka",
    meta: index6Tezf4xDR0Meta || {},
    component: () => import("/app/apps/main/pages/index.vue")
  },
  {
    name: "index___uz",
    path: "/uz",
    meta: index6Tezf4xDR0Meta || {},
    component: () => import("/app/apps/main/pages/index.vue")
  },
  {
    name: "old___ru",
    path: "/ru/old",
    meta: oldVK0re4oWPXMeta || {},
    component: () => import("/app/apps/main/pages/old.vue")
  },
  {
    name: "old___en",
    path: "/en/old",
    meta: oldVK0re4oWPXMeta || {},
    component: () => import("/app/apps/main/pages/old.vue")
  },
  {
    name: "old___ka",
    path: "/ka/old",
    meta: oldVK0re4oWPXMeta || {},
    component: () => import("/app/apps/main/pages/old.vue")
  },
  {
    name: "old___uz",
    path: "/uz/old",
    meta: oldVK0re4oWPXMeta || {},
    component: () => import("/app/apps/main/pages/old.vue")
  },
  {
    name: "partners_old___ru",
    path: "/ru/partners_old",
    meta: partners_oldh4rrhvu8bmMeta || {},
    component: () => import("/app/apps/main/pages/partners_old.vue")
  },
  {
    name: "partners_old___en",
    path: "/en/partners_old",
    meta: partners_oldh4rrhvu8bmMeta || {},
    component: () => import("/app/apps/main/pages/partners_old.vue")
  },
  {
    name: "partners_old___ka",
    path: "/ka/partners_old",
    meta: partners_oldh4rrhvu8bmMeta || {},
    component: () => import("/app/apps/main/pages/partners_old.vue")
  },
  {
    name: "partners_old___uz",
    path: "/uz/partners_old",
    meta: partners_oldh4rrhvu8bmMeta || {},
    component: () => import("/app/apps/main/pages/partners_old.vue")
  },
  {
    name: "partners___ru",
    path: "/ru/partners",
    meta: partners4d3zuQK8P5Meta || {},
    component: () => import("/app/apps/main/pages/partners.vue")
  },
  {
    name: "partners___en",
    path: "/en/partners",
    meta: partners4d3zuQK8P5Meta || {},
    component: () => import("/app/apps/main/pages/partners.vue")
  },
  {
    name: "partners___ka",
    path: "/ka/partners",
    meta: partners4d3zuQK8P5Meta || {},
    component: () => import("/app/apps/main/pages/partners.vue")
  },
  {
    name: "partners___uz",
    path: "/uz/partners",
    meta: partners4d3zuQK8P5Meta || {},
    component: () => import("/app/apps/main/pages/partners.vue")
  },
  {
    name: "questions___ru",
    path: "/ru/questions",
    component: () => import("/app/apps/main/pages/questions.vue")
  },
  {
    name: "questions___en",
    path: "/en/questions",
    component: () => import("/app/apps/main/pages/questions.vue")
  },
  {
    name: "questions___ka",
    path: "/ka/questions",
    component: () => import("/app/apps/main/pages/questions.vue")
  },
  {
    name: "questions___uz",
    path: "/uz/questions",
    component: () => import("/app/apps/main/pages/questions.vue")
  },
  {
    name: "rates___ru",
    path: "/ru/rates",
    component: () => import("/app/apps/main/pages/rates.vue")
  },
  {
    name: "rates___en",
    path: "/en/rates",
    component: () => import("/app/apps/main/pages/rates.vue")
  },
  {
    name: "rates___ka",
    path: "/ka/rates",
    component: () => import("/app/apps/main/pages/rates.vue")
  },
  {
    name: "rates___uz",
    path: "/uz/rates",
    component: () => import("/app/apps/main/pages/rates.vue")
  },
  {
    name: "registration-token___ru",
    path: "/ru/registration/:token()",
    meta: _91token_93DgAnvUd3UKMeta || {},
    component: () => import("/app/apps/main/pages/registration/[token].vue")
  },
  {
    name: "registration-token___en",
    path: "/en/registration/:token()",
    meta: _91token_93DgAnvUd3UKMeta || {},
    component: () => import("/app/apps/main/pages/registration/[token].vue")
  },
  {
    name: "registration-token___ka",
    path: "/ka/registration/:token()",
    meta: _91token_93DgAnvUd3UKMeta || {},
    component: () => import("/app/apps/main/pages/registration/[token].vue")
  },
  {
    name: "registration-token___uz",
    path: "/uz/registration/:token()",
    meta: _91token_93DgAnvUd3UKMeta || {},
    component: () => import("/app/apps/main/pages/registration/[token].vue")
  }
]